/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmailSettingsResponse } from '../../models/email-settings-response';

export interface GetEmailSettings$Params {
  tenantId: string;
  'Active-Tenant-Identifier': string;
}

export function getEmailSettings(http: HttpClient, rootUrl: string, params: GetEmailSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<EmailSettingsResponse>> {
  const rb = new RequestBuilder(rootUrl, getEmailSettings.PATH, 'get');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmailSettingsResponse>;
    })
  );
}

getEmailSettings.PATH = '/tenants/{tenantId}/email-settings';
